import React, { useMemo } from 'react';
import Styles from './Loaded.module.scss';
import Character from '../../assets/company/btb-character.jpg';
import { COOKIE_KEY_BRAND_NM, COOKIE_KEY_BRAND_ID } from '../../const/AppConst';
import Cookies from 'js-cookie';

const Loaded = () => {
  const brandName = useMemo(
    () => Cookies.get(COOKIE_KEY_BRAND_NM) || '퀀텀AI',
    [],
  );

  const close = () => {
    window.close();
  };
  return (
    <div className="sendbird-conversation">
      <div className="sendbird-chat-header">
        <div className="sendbird-chat-header__left">
          <button
            className="sendbird-chat-header__left__back sendbird-iconbutton "
            type="button"
            style={{ height: 36, width: 36 }}
            onClick={close}
          >
            <span className="sendbird-iconbutton__inner">
              <div
                className=" sendbird-icon sendbird-icon-unknown sendbird-icon-color--white"
                role="button"
                tabIndex="0"
                style={{ width: 24, minWidth: 24, height: 24, minHeight: 24 }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                  <path
                    d="M10 19l-7-7 7-7"
                    strokeLinejoin="round"
                    fill="none"
                    stroke="#222"
                    strokeLinecap="round"
                    strokeWidth="2"
                  />
                  <path
                    d="M3 12h18"
                    fill="none"
                    stroke="#222"
                    strokeLinecap="round"
                    strokeWidth="2"
                  />
                </svg>
              </div>
            </span>
          </button>
        </div>
        <div className="sendbird-chat-header__center">
          <span className="sendbird-chat-header__center__title sendbird-label sendbird-label--h-2 sendbird-label--color-onbackground-1">
            {brandName} 상담봇
          </span>
          <span className="sendbird-chat-header__center__subtitle sendbird-label sendbird-label--body-1 sendbird-label--color-onbackground-2" />
        </div>
        <div className="sendbird-chat-header__right">
          {/*<button className="sendbird-chat-header__right__info  sendbird-iconbutton " type="button" style={{height: 32, width: 32}}>
                    <span className="sendbird-iconbutton__inner">
                    <div className=" sendbird-icon sendbird-icon-info sendbird-icon-color--primary" role="button" tabIndex="0" style={{width: 24, minWidth: 24, height: 24, minHeight: 24}}>
                        {
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                            <path className="icon-info_svg__fill"
                                  d="M32 2.667C48.2 2.667 61.333 15.8 61.333 32S48.2 61.333 32 61.333 2.667 48.2 2.667 32 15.8 2.667 32 2.667zM32 8C18.745 8 8 18.745 8 32s10.745 24 24 24 24-10.745 24-24S45.255 8 32 8zm1.667 21.333a1 1 0 011 1v14a1 1 0 01-1 1h-3.334a1 1 0 01-1-1v-14a1 1 0 011-1h3.334zm-1.667-8a2.667 2.667 0 110 5.334 2.667 2.667 0 010-5.334z"
                                  fill="#000" fillRule="evenodd"/>
                        </svg>
                        }
                    </div>
                    </span>
                        </button>*/}

          <div style={{ height: 32, width: 32 }} />
        </div>
      </div>
      <div className={`sendbird-conversation__messages ${Styles.Close}`}>
        <div
          className="d-flex justify-center"
          style={{ margin: '138px 0 32px 0' }}
        >
          <img
            src={Character}
            alt="BTB Character"
            style={{
              width: '200px',
              height: '200px',
              objectFit: 'cover',
              borderRadius: '50%',
              backgroundColor: 'transparent',
            }}
          />
        </div>

        <div
          className={`d-flex flex-column justify-center align-items-center text-align-center ${Styles.Title}`}
        >
          일시적인 문제가 발생했습니다.
          <br />
          새로 고침하여 다시 시도해 주세요.
        </div>
      </div>
    </div>
  );
};

Loaded.propTypes = {};

export default Loaded;
